import Event from '../../core/Event';
import UserEstimation from '../../../domain/UserEstimation';

export default class UserEstimationsGetSucceed extends Event {
    public static type = 'UserEstimationsGetSucceed';

    constructor(public readonly estimations: UserEstimation[]) {
        super(UserEstimationsGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/UserEstimationsGetSucceed.ts